import React, { useEffect, useState, Fragment } from 'react';
import SinglePlot from '../../../../HMI/SinglePlot';
import { LinkOverlay } from '../../CSS/style';

const Image = (props) => {
  let { graphprops } = props;
  const [dynamicName, setDynamicName] = useState(props.DeviceCode);

  useEffect(() => {
    setDynamicName(props.DeviceCode);
  }, [props]);

  const images = (hmiName, type, dynamicName) => {
    return (
      <div>
        {type && type === 'static' ? (
          <LinkOverlay to={{ pathname: `/rubus/HMI/${type}/${hmiName}` }} />
        ) : (
          <LinkOverlay to={{ pathname: `/rubus/HMI/${type}/${hmiName}/${dynamicName}` }} />
        )}
        <SinglePlot
          triggerPoint="dashboard"
          match={{
            params: {
              hmiName,
              type,
              dynamicName
            }
          }}
        />
      </div>
    );
  };

  const hmiName = graphprops.image && graphprops.image.path ? graphprops.image.path : '';
  const type = graphprops.image && graphprops.image.Type ? graphprops.image.Type : '';

  return (
    <Fragment>
      {images(hmiName, type, dynamicName)}
    </Fragment>
  );
};

export default Image;